import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, FormGroup, Button } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import FormItem from '../../../common/forms/FormItem';
import { isRequired, validateEndDate } from '../../../../utils/validators';
import DatePicker from '../../../common/forms/input/DatePicker';
import PrintDetailDropdownButton from './PrintDetailDropdownButton';

const validateDate = (value, allValues) =>
  validateEndDate(value, allValues.fromDateString);

export const TollLiquidationDownloadForm = ({
  handleSubmit,
  onDownloadAdditional,
  onDownloadProvia,
  onDownloadProviaDetail,
  onDownloadDetail,
}) => (
  <Form onSubmit={handleSubmit}>
    <Row className="mb-3">
      <Col>
        <div
          style={{
            padding: '10px 15px',
            borderRadius: '8px',
            background: 'rgba(25,118,210,0.06)',
            border: '1px solid rgba(25,118,210,0.2)',
            fontSize: '14px',
          }}
        >
          Seleccione un rango de <strong>fechas de viaje (itinerario)</strong>{' '}
          para descargar los reportes en formato Excel.
        </div>
      </Col>
    </Row>

    <FormGroup row>
      <FormItem label="Desde" required>
        <Field
          name="fromDateString"
          component={DatePicker}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>

    <FormGroup row>
      <FormItem label="Hasta" required>
        <Field
          name="toDateString"
          component={DatePicker}
          validate={[isRequired, validateDate]}
        />
      </FormItem>
    </FormGroup>

    <Row>
      <Col
        className="d-flex justify-content-end flex-wrap"
        style={{ gap: '10px' }}
      >
        <PrintDetailDropdownButton
          handleSubmit={handleSubmit}
          onDownloadDetail={onDownloadDetail}
          onDownloadProviaDetail={onDownloadProviaDetail}
        />

        <Button
          type="button"
          color="warning"
          onClick={handleSubmit(onDownloadAdditional)}
        >
          <i className="fa fa-download mr-2" />
          Descargar Fundición
        </Button>

        <Button
          type="button"
          color="info"
          onClick={handleSubmit(onDownloadProvia)}
        >
          <i className="fa fa-download mr-2" />
          Descargar Provías
        </Button>

        <Button color="secondary" type="submit">
          <i className="fa fa-download mr-2" />
          Descargar Peajes
        </Button>
      </Col>
    </Row>
  </Form>
);

TollLiquidationDownloadForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,

  onDownloadAdditional: PropTypes.func.isRequired,

  onDownloadProvia: PropTypes.func.isRequired,

  onDownloadProviaDetail: PropTypes.func.isRequired,
  onDownloadDetail: PropTypes.func.isRequired,

  initialValues: PropTypes.shape({
    fromDateString: PropTypes.oneOfType([
      PropTypes.instanceOf(Date),
      PropTypes.string,
    ]),

    toDateString: PropTypes.oneOfType([
      PropTypes.instanceOf(Date),
      PropTypes.string,
    ]),
  }),
};

TollLiquidationDownloadForm.defaultProps = {
  initialValues: {
    fromDateString: null,
    toDateString: null,
  },
};

export default reduxForm({
  form: 'TollLiquidationDownloadForm',
})(TollLiquidationDownloadForm);
